import { render, staticRenderFns } from "./ClientBan.vue?vue&type=template&id=4de8e3df"
import script from "./ClientBan.vue?vue&type=script&lang=js"
export * from "./ClientBan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports